<template>
  <div>
    <VRow>
      <VBtn
        class="header__link text-capitalize d-flex align-items-center"
        color="secondary"
        text
        data-test="back-to-signin-button"
        @click="back"
      >
        <div class="d-flex align-items-center">
          <VIcon class="mr-2">
            mdi-arrow-left
          </VIcon>
          <span
            v-if="!this.$vuetify.breakpoint.smAndDown"
            class="body-1 back-btn__text"
          >
            {{ $t('authForm.back') }}
          </span>
        </div>
      </VBtn>
    </VRow>
    <VRow justify="center">
      <VCol
        class="px-2 pb-6 d-flex align-center pt-0"
        cols="12"
      >
        <div>
          <span class="body-1">
            {{ $t('authForm.phoneNumber') }}
          </span>
        </div>
        <div class="ml-2">
          <span class="body-bold">
            {{ phone }}
          </span>
        </div>
      </VCol>
      <VerificationPhone
        ref="verificationPhone"
        :receivedRemainingTime="receivedRemainingTime"
        :otpExpiredAt="otpExpiredAt"
        :phone="phone"
        :receivedErrorCode="receivedErrorCode"
        :isPasswordResetStep="true"
        @resendCode="$emit('sendVerificationCodeForExistingUser')"
        @toBlockedAuth="$emit('toBlockedAuth')"
        @onSubmit="onSubmitVerificationCode"
      />
    </VRow>
  </div>
</template>

<script lang="ts">
export default {
  name: 'ResetPasswordStep',
};
</script>

<script setup lang="ts">
import { onDeactivated, ref } from 'vue';
import VerificationPhone from '@slg/web-customer-shared/src/components/authForm/verificationPhone/VerificationPhone.vue';

const props = defineProps({
  receivedRemainingTime: {
    type: Number,
    default: null,
  },
  otpExpiredAt: {
    type: Number,
    default: 0,
  },
  phone: {
    type: String,
    default: '',
  },
  receivedErrorCode: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['recoverPassword', 'toSignInStep']);

const showNewPassword = ref(false);
const showConfirmedPassword = ref(false);
const newPassword = ref('');
const confirmedPassword = ref('');
const isNewOtpNeeded = ref(true);
const verificationPhone = ref<any>(null);

onDeactivated(() => {
  verificationPhone.value.clearOtpAndErrorCode(isNewOtpNeeded.value);
});

function onSubmitVerificationCode(verificationCode: any, attempts: any) {
  emit('recoverPassword', verificationCode, attempts, false);
}

function back() {
  isNewOtpNeeded.value = false;
  emit('toSignInStep', props.phone);
}
</script>
